import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ClickOutsideModule } from 'ng-click-outside';



import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from 'src/app/core/services/language.service';
import { UIModule } from 'src/app/shared/ui/ui.module';
import { SidebarDelphyComponent } from './sidebar-delphy/sidebar-delphy.component';
import { LayoutDelphyComponent } from './layout-delphy.component';
import { TopbarDelphyComponent } from './topbar-delphy/topbar-delphy.component';


@NgModule({
  // tslint:disable-next-line: max-line-length
  declarations: [
    LayoutDelphyComponent, 
    SidebarDelphyComponent, 
    TopbarDelphyComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    NgbDropdownModule,
    ClickOutsideModule,
    UIModule,
    PerfectScrollbarModule
  ],
  providers:[LanguageService]
})
export class LayoutsDelphyModule { }
